/* eslint-disable */
import 'focus-visible';

require('es6-promise').polyfill();
